import { ProductIds, ReportTypes } from '../apiConstants'
import { API_CALL_TYPE, getAPIUrl } from '../API'
import { API_ERROR_MESSAGE } from '../../utils/Constants'
import { makeApiCall } from '../APIService'

interface handleDownloadBankVerificationReporParams {
  reportId: string
  setErrorMessage: (value: string) => void
  setIsError: (value: boolean) => void
  setShowProgress: (value: boolean) => void
}

export const downloadReport = (
  props: handleDownloadBankVerificationReporParams,
): void => {
  const { reportId, setShowProgress, setIsError, setErrorMessage } = props
  const requestOptions: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
    },
    body: JSON.stringify({
      reportId,
      reportType: ReportTypes.WorldComplianceReport.reportTypeId,
    }),
  }
  setShowProgress(true)
  setIsError(false)
  setErrorMessage('')

  fetch(
    `${getAPIUrl()}/BankAccountVerification/download-report`,
    requestOptions,
  )
    .then((res: Response) => {
      return res.blob()
    })
    .then((blob: Blob) => {
      setShowProgress(false)
      const href = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', 'bankVerification.pdf')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
    .catch((error) => {
      setShowProgress(false)
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
      return Promise.reject({ Error: 'Something Went Wrong', error })
    })
}

interface HandleBankVerificationSearchProps {
  verificationType: number
  entity: number
  firstname: string
  surname: string
  iDorPassportNo: string
  idType: number
  companyorTrustName: string
  trustNo: string
  accountNo: string
  branchCode: string
  accountType: string
  bankName: string
  voucherCode: string
  yourReference: string
  reportType: number
  verificationReason: string
  initials: string
  setErrorMessage: (value: string) => void
  setIsError: (value: boolean) => void
  setShowProgress: (value: boolean) => void
  setReportId: (value: string) => void
  downloadReport: (reportId?: string) => void
}

export const requestBankVerificationSearch = ({
  verificationType,
  entity,
  firstname,
  surname,
  iDorPassportNo,
  idType,
  companyorTrustName,
  trustNo,
  accountNo,
  branchCode,
  accountType,
  bankName,
  voucherCode,
  yourReference,
  reportType,
  verificationReason,
  initials,
  setShowProgress,
  setIsError,
  setErrorMessage,
  setReportId,
  downloadReport,
}: HandleBankVerificationSearchProps): void => {
  const API_URL = `${getAPIUrl()}/BankAccountVerification/search-account`
  const body = {
    verificationType,
    entity,
    firstname,
    surname,
    iDorPassportNo,
    idType,
    companyorTrustName,
    trustNo,
    accountNo,
    branchCode,
    accountType,
    bankName,
    voucherCode,
    yourReference,
    verificationReason,
    initials,
    reportType: ReportTypes.BankVerificationSearch.reportTypeId,
  }
  setShowProgress(true)
  setIsError(false)
  setErrorMessage('')
  makeApiCall(
    API_CALL_TYPE.POST_CALL,
    API_URL,
    (response: { statusCode: number; data: { reportId: string } }) => {
      if (response.statusCode !== 200) {
        setIsError(true)
        setErrorMessage(API_ERROR_MESSAGE)
      } else {
        downloadReport(response.data.reportId)
        setReportId(response.data.reportId)
        setShowProgress(false)
      }
    },
    (error: { response: { data: { message: string } } }) => {
      setShowProgress(false)
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
    },
    body,
    {
      Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
    },
    null,
    false,
  )
}
